import { Chip, TableRow, useTheme } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Employee } from '../../../types/Employee/Employee'
import { StyledTableCell } from '../../core/StyledTableCell'
import { useShiftEndContext } from './ShiftEndContext'
import { TimeSheetDialog } from './TimesheetDialog'
import VerifiedIcon from '@mui/icons-material/Verified'
import CancelIcon from '@mui/icons-material/Cancel'

type ForemanRowProps = {
	directReport: Employee
	postConfirmLoadData: () => void
}

export function ShiftEndSupervisionRow({ directReport, postConfirmLoadData }: ForemanRowProps) {
	const navigate = useNavigate()
	const { appendToNavPath, shiftDate } = useShiftEndContext()
	const theme = useTheme()
	const submitted = directReport.submittedTimesheetCount ?? 0
	const total = directReport.directReportCount ?? 0
	const allSubmitted = total > 0 && submitted === total
	return (
		<>
			<TableRow
				onClick={() => {
					if (directReport.role.title === 'Foreman') navigate(`/reports/${directReport.id}/Foreman`)
					else {
						appendToNavPath(directReport)
						navigate(`/reports/${directReport.id}`)
					}
				}}
				key={directReport.id}
				sx={{
					cursor: 'pointer',
					'&:hover': {
						backgroundColor: theme.palette.action.hover,
					},
				}}
			>
				<StyledTableCell align='left'>
					{directReport.firstName} {directReport.lastName}
					{directReport.attendanceToday === 'Present' && (
						<VerifiedIcon
							sx={{
								transform: 'translate(25%, 25%)',
								color: 'green',
							}}
						/>
					)}
					{directReport.attendanceToday === 'Absent' && (
						<CancelIcon
							sx={{
								transform: 'translate(25%, 25%)',
								color: 'primary.main',
							}}
						/>
					)}
					{directReport.attendanceToday === 'Days Off' && (
						<CancelIcon
							sx={{
								transform: 'translate(25%, 25%)',
								color: 'warning.main',
							}}
						/>
					)}
				</StyledTableCell>
				<StyledTableCell align='center'>
					<TimeSheetDialog
						employee={directReport}
						postConfirmLoadData={postConfirmLoadData}
						shiftDate={shiftDate}
					/>
				</StyledTableCell>
				<StyledTableCell align='center'>{directReport.employeeId}</StyledTableCell>
				<StyledTableCell align='center'>{directReport.primaryCraft}</StyledTableCell>
				<StyledTableCell align='center'>{directReport.classification}</StyledTableCell>
				<StyledTableCell align='center'>
					<Chip label={'Online'} variant={'Online'} />
				</StyledTableCell>
				<StyledTableCell align='center'>
					<Chip
						label={`${submitted}/${total} Submitted`}
						variant={allSubmitted ? 'success' : 'failure'}
					></Chip>
				</StyledTableCell>
			</TableRow>
		</>
	)
}
